import React from "react";
import StackNavigator from "../../components/StackNavigator";
import Home from "./Home";
import PreviewItem from "./PreviewItem";

function HomeScreens() {
  const SCREENS = [
    { name: "homescreen", component: Home },
    { name: "item", component: PreviewItem },
  ];
  return <StackNavigator screens={SCREENS} />;
}

export default HomeScreens;
